import script from "./GallerySection.vue?vue&type=script&setup=true&lang=ts"
export * from "./GallerySection.vue?vue&type=script&setup=true&lang=ts"

import "./GallerySection.vue?vue&type=style&index=0&id=6f697093&lang=css"

const __exports__ = script;

export default __exports__